























































import Vue from 'vue';
import A11yHelper from '@/helpers/A11yHelper';
import { IMenuItem } from '@/common/interfaces/header.interface';
import AppHelper from '../../../helpers/AppHelper';
import DesktopDropdownSubEntry from './DesktopDropdownSubEntry.vue';
import LocalStorageHelper from '../../../helpers/LocalStorageHelper';

interface IDesktopDropdownColumnEntryComponent {
  AppHelper: typeof AppHelper;
}

export default Vue.extend({
  name: `DesktopDropdownColumnEntry`,
  components: { DesktopDropdownSubEntry },
  data(): IDesktopDropdownColumnEntryComponent {
    return {
      AppHelper,
    };
  },
  computed: {
    isPartner(): boolean {
      return LocalStorageHelper.getPersonalInfo()?.isPartner ?? false;
    },
    newNewsAmount(): number {
      return LocalStorageHelper.getNewNewsCount();
    },
  },
  props: {
    amountOfItems: {
      required: true,
      type: Number,
    },
    entry: {
      required: true,
      type: Object as () => IMenuItem[],
    },
    index: {
      required: true,
      type: Number,
    },
  },
  methods: {
    focusOut(e: FocusEvent | null): void {
      if(this.index + 1 === this.amountOfItems) {
        this.$emit(`close:dropdown`, !A11yHelper.isFocusWithinCurrentGroup(e));
      }
    },
    link(delegate: string): void {
      if(delegate === `news`) {
        this.removeNewNewsAmount();
      }
      if(delegate === `subscribeNewsletter`) {
        this.newsletterSubscribe();
      }
    },
    newsletterSubscribe(): void {
      const newsletterSection = document.getElementById(`newsletter`);
      if(window.location.pathname !== `/`) {
        window.location.href = `/#newsletter`;
      } else {
        newsletterSection?.scrollIntoView();
      }
    },
    removeNewNewsAmount(): void {
      LocalStorageHelper.removeNewNewsCount();
    },
    triggerDelegate(delegate: string): void {
      if(delegate) {
        this.link(delegate);
        this.$emit(`close:dropdown`, true);
      }
    },
  },
});
